import { Alert, Button, Stack } from '@mui/material';
import { networkErrorMessage } from '../../utils/networkError';

interface Props {
  error: unknown;
  title?: string;
  onRetry?: () => void;
}

export default function QueryErrorAlert({ error, title = 'Failed to load data', onRetry }: Props) {
  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            Retry
          </Button>
        ) : undefined
      }
    >
      <Stack spacing={0.5}>
        <strong>{title}</strong>
        {networkErrorMessage(error)}
      </Stack>
    </Alert>
  );
}
